import { UploadWidgetItemStatus } from '@shared/utils/enums';

import { UploadWidgetState } from './upload-widget.interface';

export const INITIAL_STATE: UploadWidgetState = {
  registeredUploads: [],
  isWidgetVisible: false,
};

/** Statuses whose transfer never finished and must be resumed after a refresh. */
export const RESUMABLE_STATUSES: ReadonlySet<UploadWidgetItemStatus> = new Set([
  UploadWidgetItemStatus.Initiated,
  UploadWidgetItemStatus.Uploading,
]);

export const RETAINED_FILE_STATUSES: ReadonlySet<UploadWidgetItemStatus> = new Set([
  UploadWidgetItemStatus.Initiated,
  UploadWidgetItemStatus.Uploading,
  UploadWidgetItemStatus.Failed,
]);

export const SUCCESSFUL_STATUSES: ReadonlySet<UploadWidgetItemStatus> = new Set([
  UploadWidgetItemStatus.Completed,
  UploadWidgetItemStatus.PartiallyCompleted,
  UploadWidgetItemStatus.Error,
]);

export type ToastVariant = 'success' | 'warning' | 'error' | 'failed';

/** The toast flavour a finished upload status maps to (`null` = no toast). */
export const STATUS_TOAST_VARIANT: Record<UploadWidgetItemStatus, ToastVariant | null> = {
  [UploadWidgetItemStatus.Initiated]: null,
  [UploadWidgetItemStatus.Uploading]: null,
  [UploadWidgetItemStatus.Completed]: 'success',
  [UploadWidgetItemStatus.PartiallyCompleted]: 'warning',
  [UploadWidgetItemStatus.Failed]: 'failed',
  [UploadWidgetItemStatus.Error]: 'error',
};

export const TOAST_VARIANT_I18N_KEY: Record<ToastVariant, string> = {
  success: 'success',
  warning: 'partial',
  error: 'error',
  failed: 'failed',
};

export const DEFAULT_REPORT_FILE_NAME = 'upload-report.xlsx';
